'use client';
import BundlePlus from '@/app/_components/ui/icons/BundlePlus.svg';
import { useState, useEffect } from 'react';
import Img from '../share/Img';
import useCart from '@/app/_hooks/useCart';
import PriceUnit from '../share/PriceUnit';
import LoadingIcon from '../share/LoadingIcon';
import Link from 'next/link';

export default function SpBundles({ current, bundles }) {
  const [productsInBundle, setProductsInBundle] = useState([]);
  const [totalPrice, setTotalPrice] = useState(0);
  const { addToCart, cart } = useCart();
  const [addedToCartText, setAddedToCartText] = useState(false);
  const [totalWithoutdiscount, setTotalWithoutDiscount] = useState(0);
  const [isAddingToCart, setIsAddingToCart] = useState(false);

  const addBundleProductsTocart = async () => {
    const productIdsToFilter = productsInBundle.map((item) => item.productId);
    const MergeBundles = [...bundles, current];
    const filteredItems = MergeBundles.filter((bundle) =>
      productIdsToFilter.includes(bundle.price.id)
    );

    const newItems = filteredItems.map((bundle) => ({
      number: 1,
      price_id: bundle.price.id,
      variation: {
        product: {
          media: {
            thumb: bundle.media.thumb,
          },
          slug: bundle.slug,
          title: bundle.title,
        },
        regular: bundle.price.regular,
        sale: bundle.price.sale,
      },
    }));
    try {
      setIsAddingToCart(true); // Set loading state to true
      addToCart({ items: newItems });
    } finally {
      setIsAddingToCart(false);
      setAddedToCartText(true); // Reset loading state after the addToCart action completes
    }
  };

  const handleChangeBundles = (e) => {
    const productId = parseInt(e.target.dataset.id);
    const price = parseFloat(e.target.dataset.price);
    const regular = parseFloat(e.target.dataset.regular);
    const checked = e.target.checked;

    if (checked) {
      setProductsInBundle((prevProducts) => [
        ...prevProducts,
        { productId, price, regular },
      ]);
    } else {
      setProductsInBundle((prevProducts) =>
        prevProducts.filter((product) => product.productId !== productId)
      );
    }
  };

  useEffect(() => {
    const mappedProducts = bundles
      .filter((product) => product.price !== null)
      .map((product) => ({
        productId: product.price.id,
        price: product.price.sale,
        regular: product.price.regular,
      }));
    setProductsInBundle(() => [
      {
        productId: current.price.id,
        price: current.price.sale,
        regular: current.price.regular,
      },
      ...mappedProducts,
    ]);
  }, []);

  useEffect(() => {
    setAddedToCartText(false);
    const totalPrice = productsInBundle.reduce(
      (sum, product) => sum + product.price,
      0
    );
    const totalRegular = productsInBundle.reduce(
      (sum, product) => sum + product.regular,
      0
    );
    setTotalWithoutDiscount(totalRegular);
    setTotalPrice(totalPrice);
  }, [productsInBundle, current]);

  return (
    <>
      <div className="spBundles bg-white mt-4 py-6 md:px-8 px-4 -mx-2 md:mx-0">
        <div className="spSectionTitle">
          <p className="font-bold text-sm md:text-xl text-gray-950">
            محصولاتی که اغلب با هم خریداری می‌شوند
          </p>
        </div>
        <div className="md:mt-10 mt-7 md:flex md:pb-4">
          <div className="md:w-9/12 md:flex items-center">
            <div className="bundleProductCard border  rounded-md border-border-color flex p-3 -mb-2.5 md:mb-0  w-full md:w-1/2">
              <div className="w-36">
                <Img image={current.image} width={140} height={128} />
              </div>
              <div className="pr-6">
                <div className="min-h-[90px]">
                  <p className="text-sm leading-7 max-w-[170px]">
                    {current.title}
                  </p>
                  <div className="text-sm  pt-4 flex items-center">
                    <PriceUnit price={current.price.sale} />
                  </div>
                </div>

                <div className="text-xs font-bold pt-5 items-center flex">
                  <input
                    type="checkbox"
                    data-price={current.price.sale}
                    data-id={current.price.id}
                    data-regular={current.price.regular}
                    onChange={handleChangeBundles}
                    checked={productsInBundle.some(
                      (product) => product.productId === current.price.id
                    )}
                  />
                  <label className="pr-2">افزودن به باندل</label>
                </div>
              </div>
            </div>
            <div className="plusBundleProduct px-6">
              <BundlePlus fill="#98A2B3" />
            </div>
            {bundles.map((product) => (
              <>
                {product.price && (
                  <Link
                    href={`/product/${product.slug}`}
                    target="_blank"
                    className="w-full md:w-1/2"
                  >
                    <div className="bundleProductCard border rounded-md border-border-color flex p-3  -mt-2.5 md:mt-0 ">
                      <div className="w-36">
                        <Img
                          image={product.media.thumb}
                          width={140}
                          height={128}
                        />
                      </div>
                      <div className="pr-6">
                        <div className="min-h-[90px]">
                          <p className="text-sm leading-7 max-w-[170px]">
                            {product.title}
                          </p>
                          <div className="text-sm  flex items-center pt-4">
                            <PriceUnit price={product.price.sale} />
                          </div>
                        </div>
                        <div className="text-xs pt-5 flex items-center">
                          <input
                            type="checkbox"
                            data-id={product.price.id}
                            data-price={product.price.sale}
                            data-regular={product.price.regular}
                            onChange={handleChangeBundles}
                            checked={productsInBundle.some(
                              (pr) => pr.productId === product.price.id
                            )}
                          />

                          <label className="font-bold pr-2">
                            افزودن به باندل
                          </label>
                        </div>
                      </div>
                    </div>
                  </Link>
                )}
              </>
            ))}
          </div>
          <div className="md:w-3/12">
            <div className="bundlePrice md:pr-10 pt-2 mt-3.5 md:mt-0">
              <div className="bundlePrice  text-sm">
                <div className="flex justify-center items-center md:pt-5 pt-0">
                  <p className="text-sm md:text-base text-gray-600 ">
                    قیمت کلی:
                  </p>
                  {productsInBundle.length > 0 ? (
                    <div className=" pr-2 ">
                      <div className="flex">
                        <del className="flex items-center">
                          {totalWithoutdiscount}
                        </del>
                        <span className="onsale bg-color-discount text-white rounded-md py-0.5 px-1.5 text-tiny md:text-sm mr-2 flex items-center">
                          {`%${Math.round(
                            ((totalWithoutdiscount - totalPrice) /
                              totalWithoutdiscount) *
                              100
                          )}`}
                        </span>
                      </div>

                      <div className=" text-sm font-bold items-center flex pl-2">
                        <PriceUnit price={totalPrice} />
                      </div>
                    </div>
                  ) : (
                    <span>0</span>
                  )}
                </div>

                <button
                  className="text-sm text-color-primary font-bold border border-color-primary w-full py-3 text-center mt-3 rounded-md"
                  disabled={productsInBundle.length === 0}
                  onClick={addBundleProductsTocart}
                >
                  {isAddingToCart ? (
                    <LoadingIcon />
                  ) : addedToCartText ? (
                    <span className="">کالا به سبد خرید افزوده شد</span>
                  ) : (
                    'افزودن به سبد خرید '
                  )}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
